export default "__VITE_ASSET__aK3rvpW0__"